import WaterfallComparator from './container';

export default WaterfallComparator;
